import * as React from "react";
import { connect } from "react-redux";
import { Switch, Redirect } from "react-router-dom";
import Cookies from "cookies-js";
import { withRouter } from 'react-router';
import AdalTokenRefresh from "./common/AdalTokenRefresh";

// Our stuff under here
import PrayerWall from "./prayerfeature/prayerWall";
import Terms from "./docs/terms";
import InstaDocTokenRefresh from "./common/InstaDocTokenRefresh";
import MobileAppBanner from "./common/MobileAppBanner";
import VersionUpdateBanner from "./common/VersionUpdateBanner";
import HistoryBinder from "./common/HistoryBinder";
import EnsureLoggedIn from "./common/EnsureLoggedIn";
import Header from "./header/Header";
import HeaderLoggedOut from "./header/HeaderLoggedOut";
import Footer from "./common/footer/Footer";
import FooterLoggedOut from "./common/footer/FooterLoggedOut";
import TestComponent from "../components/ecosystem/TestComponent";

import RoutePortal from "./common/RoutePortal";
import RoutePortalLoggedIn from "./common/RoutePortalLoggedIn";
import * as Tools from "../helpers/Tools";
import { throttle } from 'lodash';

import FAQ from "./docs/faq";
import Login from "./login/login";
import RegisterGAHit from "../helpers/GoogleAnalyticsAPI";
import { logUI } from "../api/andyliticsApi";
import SystemCrash from "../components/common/SystemCrash";
import SystemOutage from "../components/common/SystemOutage";

import CriticalUpdateModal from "../components/common/CriticalUpdateModal";
import * as types from "../constants/actionTypes";
import * as msgs from "../constants/textConstants";

import Spinner from "./common/spinner";
import ErrorPage from "./common/ErrorPage";
import PageNotFound from "./common/PageNotFound";

export class AppRoutes extends React.Component {

    static getDerivedStateFromError(error) {
        //debugger;
        return { hasError: true };
    }

    constructor(props, context) {
        super(props, context);
        this.state = { hadError: false };

        this.logHit = this.logHit.bind(this);
        this.getMobileBanner = this.getMobileBanner.bind(this);
        if (typeof window !== "undefined") {
            this.logHit();
        }
        this.criticalUpdateAvailable = false;
        this.isNewAppVersionAvailable = false;
        this.throttle = throttle(this.handleResize.bind(this), 150);
    }

    logHit() {
        try {
            // trackPageView doesn't work, but start/stop does
            //window.appInsights.trackPageView();
            //window.ai.flush();
            //debugger;
            const locpathname = this.props.location.pathname;
            const path = locpathname.replace('/', '.').split('/').join('.').split('-').join('.').split(':').join('.');
            const action = locpathname.replace("/", ".").split('/').length > 0 ? locpathname.replace("/", ".").split('/')[0] : '';
            const actCode = locpathname === "/" ? '.Dashboard' : action;
            logUI("MBHWeb.Event.Route" + actCode, new Date(), this.props.location.href, '', path);
            //debugger;
            window.appInsights.startTrackPage();
            window.appInsights.stopTrackPage();
            RegisterGAHit(window.document.title, this.props.location.href);
        }
        catch (e) {
            //debugger;
        }
    }

    componentDidMount() {
        if (typeof window !== 'undefined') {
            this.handleResize();
            window.addEventListener('resize', this.throttle);
        }
    }

    componentDidCatch(error, info) {
        //debugger;
        console.error(error, info);
        this.setState({ hasError: true });
        let json = { error: error, componentStack: info };
        //logUI("MBHWeb.Event.Route.Exception", new Date(), null, JSON.stringify(json));
        logUI("MBHWeb.UI.MainErrorBoundary.ComponentDidCatch", new Date(), Tools.getURLPath(), JSON.stringify(error), JSON.stringify(info));
    }

    componentWillUnmount() {
        if (typeof window !== 'undefined') {
            window.removeEventListener('resize', this.throttle);
        }
    }

    //Set the breakpoint in the store to use it in application globally. Values need to stay less than and not equal to match grid and css.
    handleResize(event) {
        if (typeof window !== 'undefined') {
            const { screenBreakPoint, setScreenBreakPoint } = this.props;
            let currentScreenBreakPt = '';
            let windowWidth = window.innerWidth;
            if (windowWidth < 375) {
                currentScreenBreakPt = msgs.XS_MOBILE;
            } else if (windowWidth < 480) {
                currentScreenBreakPt = msgs.SM_MOBILE;
            } else if (windowWidth < 768) {
                currentScreenBreakPt = msgs.MD_TABLET;
            } else if (windowWidth < 960) {
                currentScreenBreakPt = msgs.LG_TABLET;
            } else if (windowWidth < 1200) {
                currentScreenBreakPt = msgs.XL_DESKTOP;
            } else if (windowWidth < 1440) {
                currentScreenBreakPt = msgs.XXL_DESKTOP;
            } else {
                currentScreenBreakPt = msgs.XXL_DESKTOP;
            }
            if (currentScreenBreakPt !== screenBreakPoint) {
                setScreenBreakPoint(currentScreenBreakPt);
            }
        }
    }

    getMobileBanner = (serverData, isFromMobile, isMobileRedirect) => {
        if (typeof window === "undefined") {
            return null;
        }
        else {
            const NO_REDIRECT = 'noredirect'; // cookie to prevent redirect
            let isAndroid = Tools.isAndroid();
            let isIos = Tools.isIos();
            let isIPad = Tools.isIPad();
            const IS_MOBILE = 'isMobile';
            let isRegistration = Tools.isRegistrationQuery(this.props.location) && this.props.location.pathname === "/terms"; //special case handled here to check the redirection is from registration application for terms.
            const isResetPassword = this.props.location.pathname.toLowerCase() === "/resetpassword";
            let showBanner = !Cookies.get(NO_REDIRECT) && (!isIPad && (isAndroid || isIos)) && !isFromMobile && !isMobileRedirect && !isRegistration && !Tools.getItemFromSessionStorage(IS_MOBILE) && !isResetPassword; // if noredirect is not stamped and either android or iOS device then showMobileBanner
            // if already skipped and mobilePromptExpirationInDays not exceeded
            if (showBanner) {
                logUI("MBHWeb.Event.ShowMobileBanner", new Date(), this.props.location && this.props.location.pathname, JSON.stringify({ isAndroid: isAndroid, isIos: isIos, isIPad: isIPad, showBanner: showBanner }));
                return (
                    <MobileAppBanner
                        key={showBanner}
                        showBanner={showBanner}
                        mobilePromptExpirationInDays={serverData.mobilePromptExpirationInDays}
                        ssoBaseURL={serverData.ssoBaseURL}
                        isAndroid={isAndroid}
                        isIos={isIos}
                        redirectUrl={this.props.location}
                        careOptions={serverData.careOptions}
                    />);
            }
        }
    }

    render() {
        const { isServerside, location, MobileOnQueryString } = this.props;
        const { isLoggedIn, serverData, appUpdate, applicationVersion, normalAppUpdateShow, onLogoutClick } = this.props;
        const isReset = location.pathname === "/reset";
        let mobileClass = "";
        const IS_MOBILE = 'isMobile';
        const showVersionUpdateBanner = this.isNewAppVersionAvailable && normalAppUpdateShow === true && this.criticalUpdateAvailable === false;

        if (applicationVersion && appUpdate && appUpdate.response && appUpdate.response.minappversion && this.minappversion !== appUpdate.response.minappversion) {
            this.minappversion = appUpdate.response.minappversion;
            this.criticalUpdateAvailable = Tools.isNewerVersion(applicationVersion, appUpdate.response.minappversion) ? true : false;
        }

        if (this.state.hasError) {
            return <SystemCrash />;
        }

        if (appUpdate && appUpdate.response && appUpdate.response.siteoutage === true) {
            if (isLoggedIn) {
                onLogoutClick();
            }
            return <SystemOutage />;
        }

        const isFromMobile = MobileOnQueryString || Tools.isMobileQuery(location) || Tools.getItemFromSessionStorage(IS_MOBILE); // Tools.isMobileQuery(location); //getting the params from search value of location as we cannot have params at this level for specific comp.    

        //Setting to session storage if we have mobile value.
        if (isFromMobile && !Tools.getItemFromSessionStorage(IS_MOBILE)) {
            Tools.setItemToSessionStorage(IS_MOBILE, true);
        } else if (Tools.isMobileQueryDisabled(location) && Tools.getItemFromSessionStorage(IS_MOBILE)) {
            Tools.clearItemFromSessionStorage(IS_MOBILE);
        }

        if (applicationVersion && appUpdate && appUpdate.response && appUpdate.response.appVersion && this.appversion !== appUpdate.response.appVersion && this.criticalUpdateAvailable === false) {
            this.appversion = appUpdate.response.appVersion;
            this.isNewAppVersionAvailable = Tools.isNewerVersion(applicationVersion, appUpdate.response.appVersion) ? true : false;
        }

        //Temp fix to handle multiple redirects from mobile app web view.
        if (isFromMobile) {
            if (isLoggedIn && (location.pathname === "/" || location.pathname === "/login")) {
                return <Spinner />;
            } else if (!isLoggedIn && (location.pathname === "/login")) {
                //if token is not good, then showing error message if user loading in mobile app web view.
                return <div className={mobileClass}><ErrorPage heading="We're unable to proceed and may need to reload your session." subBannerMsg={"Please try again."} /></div>;
            }
        }

        return (
            <div className={mobileClass} ref={el => this.mainContainer = el}>
                <HistoryBinder />
                <AdalTokenRefresh />
                <InstaDocTokenRefresh />
                {!isServerside && <EnsureLoggedIn attributeIdleTimeoutSeconds={serverData.idleTimeoutSeconds} attributeIdleTimeoutCountdownSeconds={serverData.idleTimeoutCountdownSeconds} />}
                {(isLoggedIn && !isReset && location.pathname !== "/acceptterms" && location.pathname !== "/captureinsurance" && !isFromMobile) ?
                    <React.Fragment>
                        <Header serverData={serverData} />
                        {showVersionUpdateBanner ?
                            <VersionUpdateBanner message="This site is down for maintenance." />
                            : showVersionUpdateBanner
                                ? <VersionUpdateBanner message={serverData.versionUpdateMessage} />
                                : null
                        }
                    </React.Fragment>
                    : location.pathname === "/terms" || location.pathname === "/faq" || location.pathname === "/disclosures"
                        ? <HeaderLoggedOut />
                        : ""
                }
                <Switch>
                    {this.criticalUpdateAvailable && <CriticalUpdateModal counterValue={serverData.criticalUpdateCouterValue} />}
                    {!isLoggedIn && <RoutePortal exact path="/login" component={Login} serverData={serverData} title="Sign In to Community Support Admin" />}

                    <RoutePortalLoggedIn exact path="/" component={PrayerWall} title="Community Support Admin" />

                    {<RoutePortal exact path="/faq" component={FAQ} title="Frequently Asked Questions" />}
                    {<RoutePortal exact path="/terms" component={Terms} title="Terms and Conditions" />}
                    <RoutePortal path="/pagenotfound" component={PageNotFound} />

                    {serverData && (serverData?.environment === "TST" || serverData?.environment === "TST2") &&
                        <RoutePortalLoggedIn path="/testcomponents" component={TestComponent} title="Test Components" />
                    }

                    {isLoggedIn ?
                        (isFromMobile) ? <Redirect to="/pagenotfound" /> : <Redirect to="/" /> : <Redirect to="/login" />}

                </Switch>

                {(isLoggedIn && !isReset && !isFromMobile)
                    ? <Footer />
                    : <FooterLoggedOut />
                }
            </div>
        );
    }
}


const mapStateToProps = (state) => {
    return {
        isLoggedIn: state.domain.li,
        serverData: state.session.serverData,
        appUpdate: state.common[types.GET_APP_UPDATE],
        applicationVersion: state.session.serverData ? state.session.serverData.applicationVersion : "1.0.0.0",
        normalAppUpdateShow: state.common.normalAppUpdateShow,
        MobileOnQueryString: state.domain.mq
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        onLogoutClick: () => dispatch({ type: types.LOGOUT, logoutMessage: msgs.UserInitiatedLogoutMessage }),
        forceReload: () => dispatch({ type: types.RELOAD_KEY }),
        setScreenBreakPoint: (screenBreakPoint) => {
            dispatch({ type: types.SET_SCREEN_BREAKPOINT, screenBreakPoint });
        },
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AppRoutes));